import { HttpClient, HttpResponse } from "@angular/common/http";
import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  API_URL_GET_UPLOAD_URL,
  CASE_STUDY_GENERATE_DISPLAY_MASTER,
  CASE_STUDY_MASTER_ADD_EDIT,
  GET_INI_ADD_CASE_STUDY_DATA,
  GENERATE_DISPLAY_NEED_SEED_MATCHING
} from "manager/http-constants";
import { map } from "rxjs/operators";
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from "src/app/shared/constant/api-constant";
import {
  CONSTANT,
  IMAGE_EXTENSION,
  LOADING_KEY,
} from "src/app/shared/constant/constant";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { TOAST } from "src/app/shared/constant/primeng-constants";
import { LoadingState } from "src/app/shared/html-parts/loading/loading-state";
import { MessageService } from "primeng/api";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import { Validator } from "src/app/shared/validator/validator";
import { GENERATE_INPUT_TYPE } from "src/app/shared/generate/generate-input/constant";
import {
  MessageData,
  ToastMessageData,
} from "src/app/shared/html-parts/message-common/message-data";
import { PlatformComponent } from "../platform.component";
import { async } from "rxjs";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { LoginService } from "src/app/shared/service/login.service";

@Component({
  selector: "app-c461",
  templateUrl: "./c461.component.html",
  styleUrls: ["./c461.component.scss", "../platform.component.scss"],
})
export class C461Component extends PlatformComponent {
  file;
  file1;
  file2;
  file3;
  fileBlob;
  url1;
  url2;
  table: string = "case_study";
  confirmFlag: boolean = false;
  matchType: string;
  matchID: string = this.route.snapshot.queryParams.match_id;
  caseStudyID: string = this.route.snapshot.queryParams.case_study_id;
  seedNeedDetail;
  confirmData: object = null;
  seedsOrganizationName: string;
  needsOrganizationName: string;
  agenda_solution_overview: string;
  agenda_need_overview: string;
  selectedIconImage: string = '1';
  iconImagesFromApi: { [key: string]: SafeUrl } = {
    '1': '',
    '2': '',
  };
  uploadedImage: SafeUrl | null = '';

  c461InputForm: FormGroup = this.formBuilder.group({
    icon_image_choice: this.formBuilder.control('1'),
    overview: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          this.table,
          "overview",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    title: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          this.table,
          "title",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    initial_overview: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          this.table,
          "initial_overview",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    school_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          this.table,
          "school_name",
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    title_nursery: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          this.table,
          "title_nursery",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    initial_overview_nursery: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          this.table,
          "initial_overview_nursery",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    school_name_nursery: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          this.table,
          "school_name_nursery",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    match_information: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          this.table,
          "match_information",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    public_flg: this.formBuilder.control("0")
  });
  constructor(
    public route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private router: Router,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private http: HttpClient,
    private messageData: MessageData,
    private location: Location,
    private messageService: MessageService,
    private sanitizer: DomSanitizer,
    public loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);
  }

  ngOnInit(): void {
    this.router.navigate(["pages/platform/c461/" + this.inputType], {
      queryParams: {
        screenId: "c461",
        match_id: this.matchID,
        case_study_id: this.caseStudyID,
      },
    });
    if (this.inputType == GENERATE_INPUT_TYPE.NEW) {
      this.getNewIniData();
    } else {
      this.getEditDuplicateIniData();
    }
  }

  moveC462() {
    const choice = this.c461InputForm.get("icon_image_choice")?.value
    console.log(choice);
    let image;
    if (choice === "3") {
      image = this.uploadedImage
    } else {
      image = this.iconImagesFromApi[choice]
    }
    this.confirmData = {
      seedsOrganizationName: this.seedsOrganizationName,
      needsOrganizationName: this.needsOrganizationName,
      image: image,
      overview: this.c461InputForm.get("overview")?.value,
      title: this.c461InputForm.get("title")?.value,
      initial_overview: this.c461InputForm.get("initial_overview")?.value,
      school_name: this.c461InputForm.get("school_name")?.value,
      title_nursery: this.c461InputForm.get("title_nursery")?.value,
      initial_overview_nursery: this.c461InputForm.get("initial_overview_nursery")?.value,
      school_name_nursery: this.c461InputForm.get("school_name_nursery")?.value,
      match_information: this.c461InputForm.get("match_information")?.value,
      public_flg: this.c461InputForm.get("public_flg")?.value
    };
    this.router.navigate(["pages/platform/c461/" + this.inputType], {
      queryParams: {
        screenId: "c462",
        case_study_id: this.caseStudyID,
        match_id: this.matchID,
      },
    });
    // this.c461InputForm.get('public_flg').disable();

    this.confirmFlag = true;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  moveC461() {
    this.router.navigate(["pages/platform/c461/" + this.inputType], {
      queryParams: {
        screenId: "c462",
        case_study_id: this.caseStudyID,
        match_id: this.matchID,
      },
    });
    // this.c461InputForm.get('public_flg').enable();
    this.confirmFlag = false;
  }
  async moveC463() {
    this.loadingState.loadStart(CASE_STUDY_MASTER_ADD_EDIT);
    let formData: any = JSON.parse(JSON.stringify(this.c461InputForm.value));
    const choice = this.c461InputForm.get("icon_image_choice")?.value
    if (choice === "3") {
      this.file = this.file3
    } else if (choice === "1") {
      this.file = this.file1
    } else {
      this.file = this.file2
    }
    formData.image = ''
    formData.match_id = this.matchID;
    formData.case_study_id = this.caseStudyID;
    // formData.public_flg = this.c461InputForm.get('public_flg').value;
    console.log(this.file);

    if (this.file) {
      formData.image = this.file.name
      await this.uploadFiletoS3(this.file);
    }
    if (GENERATE_INPUT_TYPE.EDIT != this.inputType) {

      this.dbOperationService
        .insertData(CASE_STUDY_MASTER_ADD_EDIT, formData)
        .subscribe((response) => {
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);
          if (this.commonService.checkInvalidValue(response)) {
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.WARN,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E00026),
              })
            );

            this.confirmFlag = false;
          } else if (API_RESPONSE.FAIL == response.body.Message) {
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );
            this.confirmFlag = false;
          } else {
            this.router.navigate(["pages/platform/c361/" + response.body.case_study_id]);
            this.loadingState.loadSleepEnd(0.3, CASE_STUDY_MASTER_ADD_EDIT);
          }
          this.loadingState.loadSleepEnd(0.3, CASE_STUDY_MASTER_ADD_EDIT);
        });
    } else {
      this.dbOperationService
        .updateData(
          CASE_STUDY_MASTER_ADD_EDIT + "/",
          this.caseStudyID,
          formData
        )
        .subscribe((response) => {
          if (API_RESPONSE.FAIL != response.body.Message) {
            this.router.navigate(["pages/platform/c361/" + this.caseStudyID]);
          } else {
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            this.confirmFlag = false;
          }
          this.loadingState.loadSleepEnd(0.3, CASE_STUDY_MASTER_ADD_EDIT);
        });
    }
  }

  public getNewIniData() {
    const endpoint = GET_INI_ADD_CASE_STUDY_DATA;
    this.loadingState.loadStart(endpoint);

    return new Promise<any>((resolve) => {
      this.dbOperationService
        .getNoTemplateData(
          GET_INI_ADD_CASE_STUDY_DATA,
          { match_id: this.matchID },
          false
        )
        .subscribe((response) => {
          this.loadingState.loadSleepEnd(0.3, endpoint);
          this.getDetailSeedNeed();
          this.setFormControlValue(response.body);

          resolve(null);
        });
    });
  }

  public getEditDuplicateIniData() {
    const endpoint = CASE_STUDY_GENERATE_DISPLAY_MASTER;
    this.loadingState.loadStart(endpoint);

    return new Promise<any>((resolve) => {
      this.dbOperationService
        .getNoTemplateDisplayData(
          CASE_STUDY_GENERATE_DISPLAY_MASTER,
          this.caseStudyID + "?TemplateID=3504",
          false
        )
        .subscribe((response) => {
          this.loadingState.loadSleepEnd(0.3, endpoint);
          this.setFormControlValue(response.body);
          // this.getDetailSeedNeed();
          resolve(null);
        });
    });
  }

  /**
   * 課題・ソリューション詳細を取得
   */
  public getDetailSeedNeed() {
    // 課題・ソリューション詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayDataMultipleArgPost(GENERATE_DISPLAY_NEED_SEED_MATCHING, this.matchID)
      .subscribe((response) => {

        if (this.commonService.checkInvalidValue(response)) {
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );
        } else {
          this.seedNeedDetail = response.body
        }
      });
  }

  public async setFormControlValue(initialData) {

    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
      for (const property in initialData) {
        let formControlName: string;
        let value: any;
        formControlName = property;
        value = initialData[formControlName];
        switch (property) {
          case 'needs_organization_name':
            this.needsOrganizationName = value
            continue;
          case 'seeds_organization_name':
            this.seedsOrganizationName = value
            continue;
          case 'agenda_solution_overview':
            this.agenda_solution_overview = value
            continue;
          case 'agenda_need_overview':
            this.agenda_need_overview = value
            continue;
          case 'agenda_need_icon_image':
            continue;
          case 'agenda_solution_icon_image':
            continue;
          default:
            break;
        }
        this.setvalue(formControlName, value);
      }

      if (initialData.agenda_need_icon_image && initialData.agenda_need_icon_image["name"] && initialData.agenda_need_icon_image["base64"] && initialData.agenda_need_icon_image["url"]) {
        let value: any;
        value = initialData.agenda_need_icon_image["name"];
        const imageBlob = this.dataURItoBlob(initialData.agenda_need_icon_image["base64"]);
        const imageFile = new File([imageBlob], value);
        this.file2 = imageFile;
        this.url2 = initialData.agenda_need_icon_image["url"]
        this.iconImagesFromApi['2'] = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(this.file2)
        );
        // this.setvalue("icon_image", value);
      }
      if (initialData.agenda_solution_icon_image && initialData.agenda_solution_icon_image["name"] && initialData.agenda_solution_icon_image["base64"] && initialData.agenda_solution_icon_image["url"]) {
        let value: any;
        value = initialData.agenda_solution_icon_image["name"];
        const imageBlob = this.dataURItoBlob(initialData.agenda_solution_icon_image["base64"]);
        const imageFile = new File([imageBlob], value);
        this.file1 = imageFile;
        this.url1 = initialData.agenda_solution_icon_image["url"]
        this.iconImagesFromApi['1'] = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(this.file1)
        );
        // this.setvalue("icon_image", value);
      }
    } else {
      for (const element of initialData) {
        let formControlName: string;
        let value: any;
        formControlName = element["column_id"].replace(this.table + "_", "");

        switch (formControlName) {
          case "image":
            if (element["data"]["name"] && element["data"]["url"]) {
              value = element["data"]["name"]
              const url = element["data"]["url"]
              const base64 = await this.getBase64FromUrl(url);
              const base64String = base64.split(';base64,')[1];
              // 詳細情報のカラム値をフォームコントロールに格納
              const imageBlob = this.dataURItoBlob(base64String);
              const imageFile = new File([imageBlob], value);
              this.file = imageFile;
              this.fileBlob = this.sanitizer.bypassSecurityTrustUrl(
                URL.createObjectURL(this.file)
              );
            } else {
              value = '';
            }
            continue;
          case "agenda_solution_icon_image":
            if (element["data"]["name"] && element["data"]["base64"] && element["data"]["url"]) {
              value = element["data"]["name"];
              const imageBlob = this.dataURItoBlob(element["data"]["base64"]);
              const imageFile = new File([imageBlob], value);
              this.file1 = imageFile;
              this.url1 = element["data"]["url"]
              this.iconImagesFromApi['1'] = this.sanitizer.bypassSecurityTrustUrl(
                URL.createObjectURL(this.file1)
              );
            } else {
              value = '';
            }
            continue;
          case "agenda_need_icon_image":
            if (element["data"]["name"] && element["data"]["base64"] && element["data"]["url"]) {
              value = element["data"]["name"];
              const imageBlob = this.dataURItoBlob(element["data"]["base64"]);
              const imageFile = new File([imageBlob], value);
              this.file2 = imageFile;
              this.url2 = element["data"]["url"]
              this.iconImagesFromApi['2'] = this.sanitizer.bypassSecurityTrustUrl(
                URL.createObjectURL(this.file2)
              );
            } else {
              value = '';
            }
            continue;
          case 'needs_organization_name':
            this.needsOrganizationName = element["data"]
            continue;
          case 'seeds_organization_name':
            this.seedsOrganizationName = element["data"]
            continue;
          case 'agenda_solution_overview':
            this.agenda_solution_overview = element["data"]
            continue;
          case 'agenda_need_overview':
            this.agenda_need_overview = element["data"]
            continue;
          case "match_id":
            this.matchID = element["data"];
            continue;
          case "public_flg":
            value = element["data_multi"][0];
            break
          case 'icon_image_choice':
            value = element["data"]
            if (value == '2') {
              this.file2 = this.file
            } else if (value == '1') {
              this.file1 = this.file
            }
            else {
              this.file3 = this.file;
              this.uploadedImage = this.fileBlob
            }
            break;
          default:
            value = element["data"];
            break;
        }
        this.setvalue(formControlName, value);
      }
    }
  }
  setvalue(formControlName: string, value: any) {
    this.c461InputForm.get(formControlName).setValue(value);
    this.c461InputForm.get(formControlName).markAsDirty();
  }

  async uploadFile(uploadedFile, fileUpload, event?) {
    let fileObj: File = null;
    if (event) {
      fileObj = event.currentFiles[0];
      uploadedFile = event.currentFiles[0]
    } else {
      fileObj = uploadedFile;
    }

    // Obtain an file extension
    const fileExtension = fileObj.name.substring(
      uploadedFile.name.lastIndexOf(CONSTANT.PERIOD)
    );

    let valid = true;
    if (
      !(
        IMAGE_EXTENSION.JPG == fileExtension ||
        IMAGE_EXTENSION.JPEG == fileExtension ||
        IMAGE_EXTENSION.PNG == fileExtension ||
        IMAGE_EXTENSION.JPG2 == fileExtension ||
        IMAGE_EXTENSION.JPEG2 == fileExtension ||
        IMAGE_EXTENSION.PNG2 == fileExtension
      )
    ) {
      // Invalid image File

      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.commonService.msg(MESSAGE_CODE.E00009),
        detail: this.commonService.msg(
          MESSAGE_CODE.E00010,
          "JPEG形式（jpg・jpeg）、PNG形式（png）"
        ),
      });

      valid = false;
    } else if (fileObj.size > CONSTANT.MAX_FILE_SIZE) {

      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.commonService.msg(MESSAGE_CODE.E00009),
        detail: this.commonService.msg(MESSAGE_CODE.E00031, CONSTANT.MAX_FILE_SIZE_text),
      });
      valid = false;

    } else if (this.checkFileNameLength(fileObj.name)) {
      const sumary = this.commonService.msg(MESSAGE_CODE.E00009);
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: sumary,
        detail: this.commonService.msg(MESSAGE_CODE.E00035),
      });
      valid = false;
    }

    if (['image/jpeg', 'image/png', 'image/jpg'].includes(fileObj.type)) {
      let orientationImage: any = 0
      orientationImage = await this.getOrientation(fileObj);
      if ([2, 3, 4, 5, 6, 7, 8].includes(orientationImage)) {
        console.log("orientationImage");

        // let dataBu = await this.readImage(fileObj)
        let dataImage = await this.readImage2(fileObj)
        const rawDataImage: any = await this.processData2(dataImage, fileObj.type)

        // const raw = this.processData(dataBu, fileObj.type)
        // const file = new File([raw], fileObj.name, { type: fileObj.type });
        // fileObj = file
        await this.urlToFile(rawDataImage, fileObj.name, { type: fileObj.type })
          .then(function (file) {
            fileObj = file;
          });
        // this.getOrientation(fileObj, function(orientation) {
        //   console.log("orientation: " + orientation);
        //   self.orientationImage = orientation;
        // });
      }
    }

    if (!valid) {
      // If file is invalid
      // Clear the button operation statusuploadFile
      fileUpload.clear();
      // this.c461InputForm.get("icon_image").setValue('');
      // Processing is terminated
      return;
    } else {
      // this.c461InputForm.get("icon_image").setValue(uploadedFile.name);
      this.uploadedImage = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(fileObj)
      );
      this.file3 = fileObj;
    }
  }
  processData2(data: any, type: any) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = function (e: any) {
        // const orientation = 6;

        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        let x = 0;
        let y = 0;
        ctx.save();
        // if (orientation == 2) {
        //   x = -canvas.width;
        //   ctx.scale(-1, 1);
        // } else if (orientation == 3) {
        //   x = -canvas.width;
        //   y = -canvas.height;
        //   ctx.scale(-1, -1);
        // } else if (orientation == 3) {
        //   x = -canvas.width;
        //   y = -canvas.height;
        //   ctx.scale(-1, -1);
        // } else if (orientation == 4) {
        //   y = -canvas.height;
        //   ctx.scale(1, -1);
        // } else if (orientation == 5) {
        //   canvas.width = image.height;
        //   canvas.height = image.width;
        //   ctx.translate(canvas.width, canvas.height / canvas.width);
        //   ctx.rotate(Math.PI / 2);
        //   y = -canvas.width;
        //   ctx.scale(1, -1);
        // } else if (orientation == 6) {
        let heightCanvas = image.height
        let widthCanvas = image.width
        if (heightCanvas > 400 || widthCanvas > 400) {
          if (image.height / image.width > 1) {
            widthCanvas = image.width * 400 / image.height
            heightCanvas = 400
          } else {
            heightCanvas = image.height * 400 / image.width
            widthCanvas = 400
          }
        }
        // console.log(widthCanvas);
        // console.log(heightCanvas);
        canvas.width = widthCanvas;
        canvas.height = heightCanvas;
        // ctx.translate(canvas.width, canvas.height / canvas.width);
        // ctx.rotate(Math.PI / 2);
        // } else if (orientation == 7) {
        //   canvas.width = image.height;
        //   canvas.height = image.width;
        //   ctx.translate(canvas.width, canvas.height / canvas.width);
        //   ctx.rotate(Math.PI / 2);
        //   x = -canvas.height;
        //   ctx.scale(-1, 1);
        // } else if (orientation == 8) {
        //   canvas.width = image.height;
        //   canvas.height = image.width;
        //   ctx.translate(canvas.width, canvas.height / canvas.width);
        //   ctx.rotate(Math.PI / 2);
        //   x = -canvas.height;
        //   y = -canvas.width;
        //   ctx.scale(-1, -1);
        // }
        ctx.drawImage(image, x, y, widthCanvas, heightCanvas);
        ctx.restore();
        // console.log(type);

        const dataURL = canvas.toDataURL(type);
        resolve(dataURL);

      };
      image.src = data;
    });
  }
  readImage2(fileObj: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        resolve(e.target.result);
      };

      reader.onerror = (e) => {
        reject(false);
      };

      reader.readAsDataURL(fileObj);
    });
  };

  async urlToFile(url: any, filename: any, mimeType: any) {
    if (url.startsWith('data:')) {
      let arr = url.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const file = new File([u8arr], filename, { type: mime || mimeType });
      return Promise.resolve(file);
    }
    const res = await fetch(url);
    const buf = await res.arrayBuffer();
    return new File([buf], filename, { type: mimeType });
  }
  getOrientation = (file: File) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: ProgressEvent) => {
        if (!event.target) {
          resolve(null);
        }
        const file = event.target as FileReader;
        const view = new DataView(file.result as ArrayBuffer);
        if (view.getUint16(0, false) != 0xFFD8) {
          resolve(-2);
        }
        const length = view.byteLength
        let offset = 2;
        while (offset < length) {
          if (view.getUint16(offset + 2, false) <= 8) resolve(-1);
          let marker = view.getUint16(offset, false);
          offset += 2;
          if (marker == 0xFFE1) {
            if (view.getUint32(offset += 2, false) != 0x45786966) {
              resolve(-1);
            }

            let little = view.getUint16(offset += 6, false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            let tags = view.getUint16(offset, little);
            offset += 2;
            for (let i = 0; i < tags; i++) {
              if (view.getUint16(offset + (i * 12), little) == 0x0112) {
                resolve(view.getUint16(offset + (i * 12) + 8, little));
              }
            }
          } else if ((marker & 0xFF00) != 0xFF00) {
            break;
          }
          else {
            offset += view.getUint16(offset, false);
          }
        }
        resolve(-1);
      };

      reader.readAsArrayBuffer(file);
    });
  }
  clearFile(fileUpload: any) {
    fileUpload.clear();
    this.uploadedImage = '';
    this.file3 = '';
    this.file = '';
    // this.c461InputForm.get("icon_image").setValue('');
  }

  drop(e, fieUpload) {
    e.preventDefault();
    if (e.dataTransfer.files) {
      this.uploadFile(e.dataTransfer.files[0], fieUpload);
    }
  }

  public async uploadFiletoS3(fileUploaded: File) {
    const uploadInfo: any = await this._getUploadInfo(fileUploaded.name);

    if (
      uploadInfo.url === undefined ||
      uploadInfo.url === null ||
      uploadInfo.url.length === 0 ||
      uploadInfo.url.indexOf("s3.amazonaws.com") === -1
    ) {
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.commonService.msg(MESSAGE_CODE.I00005),
        detail: this.commonService.msg(MESSAGE_CODE.E00002),
      });
      return;
    }
    await this._uploadToS3(uploadInfo, fileUploaded);
  }

  private _getUploadInfo(filename) {
    const url = this.commonService.url(API_URL_GET_UPLOAD_URL);
    return this.http
      .get(url, {
        params: {
          tablename: this.table,
          filetype: "image",
          colname: "image",
          filename: encodeURIComponent(filename),
          code:
            this.inputType == GENERATE_INPUT_TYPE.EDIT ? this.caseStudyID : "",
        },
      })
      .toPromise();
  }

  private _uploadToS3(uploadInfo, fileUpload) {
    return new Promise<any>((resolve) => {
      const uploadUrl = uploadInfo.url;
      const fields: any = uploadInfo.fields;

      const formData = new FormData();
      Object.entries(uploadInfo.fields).forEach(([k, v]) => formData.append(k, String(v)));
      formData.append("file", fileUpload, fileUpload.name);

      this.http
        .post(uploadUrl, formData, { observe: "response" })
        .pipe(map((res: HttpResponse<any>) => res))
        .subscribe((res) => resolve(res));
    });
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array]);
    return blob;
  }

  onClick(id: string) {
    const urlMap: { [key: string]: string } = {
      '1': this.url1,
      '2': this.url2,
    };

    const url = urlMap[id];
    if (url) {
      window.open(url, '_blank');
    }
  }
  getBase64FromUrl(url: string): Promise<string> {
    return this.http.get(url, { responseType: 'blob' }).toPromise().then(blob => {
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result as string);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    });
  }
}
